import { get, patch, post } from "utils/api";

export const getOrganizations = async () => get("/organisations");

export const getOrganizationById = async (id: string) =>
  get(`/organisations/${id}`);

export const getOrganizationUsers = async (id: string) =>
  get(`/organisations/${id}/users`);

export const moveUsersToOrganization = async (
  currentOrganizationId: string,
  newOrganizationId: string,
  userIds: string[]
) =>
  post(
    `/organisations/${
      currentOrganizationId !== "" ? currentOrganizationId : newOrganizationId
    }/users/move`,
    currentOrganizationId !== ""
      ? {
          des_organisation_id: newOrganizationId,
          users: userIds,
        }
      : {
          users: userIds,
        }
  );

export const getAllUsers = async () => get("/users");

export const getUnassignedUsers = async () => get("/users/not_assigned");

export const getPendingUsers = async () => get("/users/pending");

export const acceptRejectPendingUsers = async (
  user_invitation_id: string,
  action: string
) => patch(`/invitation/${user_invitation_id}/${action}`);
